export const BOOT_FAILURE_MESSAGE = "This page failed to load. Please reload to try again.";
